import React from "react";
import Flagship from "../../core/flagship";
import DropzoneS3Uploader from "react-dropzone-s3-uploader";
import {
  getFormattedValue,
  getTimezone,
  basename,
  extension,
  directory
} from "../../utils/helpers";
import Griddle, {
  RowDefinition,
  ColumnDefinition,
  plugins
} from "griddle-react";
import Filter from "./SingleRecordFilesFilter";
import { Segment, Header, Button, Loader, Icon } from "semantic-ui-react";
import connect from "react-redux/es/connect/connect";
import { bindActionCreators } from "redux";
import * as actions from "../../actions/appActions";
import moment from "moment-timezone";
import RenameFileModal from "../modals/RenameFileModal";

const debounce = (fn, delay) => {
  let timer = null;
  return function(...args) {
    const context = this;
    timer && clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(context, args);
    }, delay);
  };
};

class SingleRecordFiles extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.getFiles = this.getFiles.bind(this);
    this.getFiles = debounce(this.getFiles, 600);
    this.getSignedUrl = this.getSignedUrl.bind(this);
    this.uploadError = this.uploadError.bind(this);
    this.missingFiles = this.missingFiles.bind(this);
    this.handleFinishedUpload = this.handleFinishedUpload.bind(this);
    this.uploadProgress = this.uploadProgress.bind(this);
    this.uploaderChildren = this.uploaderChildren.bind(this);
    this.renderFilesInner = this.renderFilesInner.bind(this);
    this.handleDragEnter = this.handleDragEnter.bind(this);
    this.handleDragLeave = this.handleDragLeave.bind(this);
    this.renderAsTable = this.renderAsTable.bind(this);
    this.onViewDownloadFile = this.onViewDownloadFile.bind(this);
    this.onRenameFile = this.onRenameFile.bind(this);
    this.onArchiveFile = this.onArchiveFile.bind(this);
    this.onUnarchiveFile = this.onUnarchiveFile.bind(this);
    this.cancelRenameFile = this.cancelRenameFile.bind(this);
    this.beforeSaveNewFilename = this.beforeSaveNewFilename.bind(this);
    this.setViewingArchived = this.setViewingArchived.bind(this);
    this.simplerLayout = this.simplerLayout.bind(this);

    this.s3Url = "https://" + Flagship.config.awsBucket + ".s3.amazonaws.com";
    this.state = {
      files: [],
      loading: true,
      uploading: false,
      dragging: false,
      progress: 0,
      renamingFile: false,
      viewingArchived: false,
      archiving: false
    };
  }

  componentDidMount() {
    this.getFiles();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.recordId !== this.props.recordId ||
      prevProps.folder !== this.props.folder
    ) {
      this.getFiles(true);
    }
  }

  handleFinishedUpload(data) {
    this.setState({
      uploading: false,
      dragging: false,
      progress: 0
    });

    this.getFiles();
    Flagship.notify("File Uploaded.", "success");
    Flagship.event(
      "file-upload",
      data.file.name,
      this.props.recordId,
      this.props.userId
    );
  }

  uploadError(err) {
    Flagship.error(
      "Upload failed. " + err,
      this.props.recordId,
      this.props.userId
    );
  }

  getFiles(resetFiles = false) {
    let self = this;
    const folder = this.props.folder;

    this.setState(
      Object.assign(
        {
          loading: true
        },
        resetFiles === true
          ? {
              files: [],
              renamingFile: false
            }
          : {}
      ),
      function() {
        Flagship.get(
          "s3/list",
          {
            bucket: Flagship.config.awsBucket,
            folder
          },
          function(response) {
            if (self.props.folder !== folder) {
              return;
            }

            if (
              response.data.success === true &&
              response.data.files !== null
            ) {
              self.setState({
                files: response.data.files,
                loading: false
              });
            } else if (response.data.files === null) {
              self.setState({
                files: [],
                loading: false
              });
            } else {
              self.setState({
                files: [],
                loading: false
              });
              Flagship.error(
                "Failed to list files.",
                self.props.recordId,
                self.props.userId
              );
            }
          },
          function(err) {
            if (self.props.folder !== folder) {
              return;
            }

            self.setState({
              files: [],
              loading: false
            });
            Flagship.error(
              "Failed to list files: " + err,
              self.props.recordId,
              self.props.userId
            );
          }
        );
      }
    );
  }

  getSignedUrl(file, callback) {
    let self = this;
    let fileName = file.name.replace("%20", " ");
    Flagship.get(
      "s3/sign",
      {
        bucket: Flagship.config.awsBucket,
        objectName: self.props.folder + "/" + fileName,
        contentType: file.type
      },
      function(data) {
        callback(data.data);
      },
      function(err) {
        if (typeof console.error === "function") {
          console.error(err);
        }
      }
    );
  }

  stopEvents(e) {
    e.persist();
    e.preventDefault();
    e.stopPropagation();
  }

  onViewDownloadFile(e, file) {
    this.stopEvents(e);
    window.open(Flagship.config.apiBase + "file?path=" + file);
  }

  onRenameFile(e, file) {
    this.stopEvents(e);
    this.setState({
      renamingFile: file
    });
  }

  setArchiving(fileObj) {
    let newObj = Object.assign({}, fileObj);
    newObj.archiving = true;
    return newObj;
  }

  onArchiveFile(e, file) {
    this.stopEvents(e);
    let setArchiving = this.setArchiving;
    let self = this;
    let newFiles = this.state.files.map(f =>
      f.Key === file ? setArchiving(f) : f
    );
    this.setState({
      files: newFiles
    });

    let newFilePath =
      directory(file) + "_archived/" + basename(file) + "." + extension(file);

    Flagship.post(
      "rename-file",
      {
        initialFilename: file,
        newFilename: newFilePath
      },
      function(response) {
        if (response.data.success === true) {
          Flagship.notify("File archived.");
          let newFiles = self.state.files.filter(f => f.Key !== file);
          self.setState(
            {
              files: newFiles
            },
            self.getFiles
          );
        } else {
          Flagship.error("Error archiving file: " + response);
          self.getFiles();
        }
      }
    );
  }

  setViewingArchived(value) {
    this.setState(
      {
        viewingArchived: value
      },
      this.getFiles
    );
  }

  onUnarchiveFile(e, file) {
    this.stopEvents(e);
    let setArchiving = this.setArchiving;
    let self = this;
    let newFiles = this.state.files.map(f =>
      f.Key === file ? setArchiving(f) : f
    );
    this.setState({
      files: newFiles
    });

    let newFilePath = file.replace("_archived/", "");

    Flagship.post(
      "rename-file",
      {
        initialFilename: file,
        newFilename: newFilePath
      },
      function(response) {
        if (response.data.success === true) {
          Flagship.notify("File unarchived.");
          let newFiles = self.state.files.filter(f => f.Key !== file);
          self.setState(
            {
              files: newFiles
            },
            self.getFiles
          );
        } else {
          Flagship.error("Error unarchiving file: " + response);
          self.getFiles();
        }
      }
    );
  }

  missingFiles() {
    return this.state.loading ? (
      <Loader
        color="blue"
        className="flagship-loader"
        active
        inline="centered"
      />
    ) : (
      <div className="cf no-files-found">No files found.</div>
    );
  }

  uploadProgress(uploader, progress) {
    this.setState({
      uploading: true,
      dragging: false,
      progress
    });
  }

  renderFilesInner() {
    if (this.state.uploading) {
      return (
        <div className="upload-progress">
          <Loader
            color="blue"
            className="flagship-loader"
            active
            inline="centered"
          />
          <div className="uploading-text">
            {typeof this.state.progress === "number"
              ? this.state.progress + "%"
              : this.state.progress}
          </div>
        </div>
      );
    }

    return <div>{this.renderAsTable()}</div>;
  }

  uploaderChildren() {
    return (
      <Segment>
        {this.renderFilesInner()}
        {this.state.dragging ? (
          <div className="files-add-bottom">
            <em className="files-drag-and-drop">Drop files here.</em>
          </div>
        ) : (
          <div className="files-add-bottom">
            <Button primary icon="plus" content="Add Files" />
            <em className="files-drag-and-drop">
              Or drag and drop files right into this box.
            </em>
          </div>
        )}
      </Segment>
    );
  }

  simplerLayout({ Table, Filter }) {
    let stopEvents = this.stopEvents;

    return (
      <div>
        <div className="single-record-files-heading">
          <div className="files-heading-left" onClick={e => stopEvents(e)}>
            <Header as="h3">Files</Header>
            <Filter
              folder={this.props.folder}
              setViewingArchived={this.setViewingArchived}
            />
          </div>
          <div className="add-files-right">
            <Button primary icon="plus" content="Add Files" />
          </div>
        </div>
        <div className="single-record-files-box" onClick={e => stopEvents(e)}>
          <div className="ui table">
            <Table />
          </div>
        </div>
      </div>
    );
  }

  renderAsTable() {
    let onViewDownloadFile = this.onViewDownloadFile;
    let timezone = getTimezone(this.props.userMarket);
    let userMarket = this.props.userMarket;
    let viewingArchived = this.state.viewingArchived;
    let data = [];

    if (this.state.files.length) {
      this.state.files.map(function(file) {
        let isArchived = file.Key.includes("/_archived/");
        if (
          (viewingArchived === true && isArchived) ||
          (viewingArchived === false && !isArchived)
        )
          data.push({
            filename: file.Key,
            filesize: file.Size,
            date: file.LastModified,
            actions: file.Key,
            archived: viewingArchived,
            archiving: file.archiving
          });
      });

      const sortProperties = [{ id: "date", sortAscending: false }];

      const CustomRowComponent = connect((state, props) => ({
        rowData: plugins.LocalPlugin.selectors.rowDataSelector(state, props)
      }))(({ rowData }) => {
        return (
          <tr className="griddle-row">
            <td
              className="griddle-cell filename"
              onClick={e =>
                onViewDownloadFile(e, encodeURIComponent(rowData.actions))
              }
            >
              <span>
                {rowData.archived ? (
                  <span className="file-archived">
                    <Icon name="archive" />
                  </span>
                ) : null}{" "}
                {basename(rowData.filename) + "." + extension(rowData.filename)}
              </span>
            </td>
            <td className="griddle-cell">
              {getFormattedValue(rowData.filesize, "filesize")}
            </td>
            <td className="griddle-cell date-time-wrap">
              <span className="date">
                {moment(rowData.date)
                  .tz(timezone)
                  .format("MM/DD/YY")}
              </span>
              <span className="time">
                {moment(rowData.date)
                  .tz(timezone)
                  .format("LT z")}
              </span>
            </td>
            <td className="griddle-cell more-actions">
              {userMarket === "Hub" && rowData.archiving ? (
                <span>Moving File...</span>
              ) : (
                <span>
                  <a
                    onClick={e =>
                      onViewDownloadFile(e, encodeURIComponent(rowData.actions))
                    }
                  >
                    Download
                  </a>
                  <a onClick={e => this.onRenameFile(e, rowData.actions)}>
                    Rename
                  </a>
                  {userMarket === "Hub" && !rowData.archiving ? (
                    <span>
                      {rowData.archived !== true ? (
                        <a
                          onClick={e => this.onArchiveFile(e, rowData.actions)}
                        >
                          Archive
                        </a>
                      ) : (
                        <a
                          onClick={e =>
                            this.onUnarchiveFile(e, rowData.actions)
                          }
                        >
                          Unarchive
                        </a>
                      )}
                    </span>
                  ) : null}
                </span>
              )}
            </td>
          </tr>
        );
      });

      return (
        <Griddle
          sortProperties={sortProperties}
          pageProperties={{
            pageSize: 999
          }}
          components={{
            Filter,
            Layout: this.simplerLayout,
            Row: CustomRowComponent
          }}
          data={data}
          plugins={[plugins.LocalPlugin]}
        >
          <RowDefinition>
            <ColumnDefinition
              id="filename"
              title="Filename"
              sortMethod={(data, column, sortAscending) => {
                let weightVal = 1;
                if (sortAscending !== true) {
                  weightVal = -1;
                }

                let newData = data.sort((a, b) => {
                  let aText = a.get("filename").toLowerCase();
                  let bText = b.get("filename").toLowerCase();
                  if (aText > bText) {
                    return weightVal;
                  } else if (bText > aText) {
                    return weightVal * -1;
                  }
                  return 0;
                });
                return newData;
              }}
            />
            <ColumnDefinition
              id="filesize"
              title="Size"
              sortMethod={(data, column, sortAscending) => {
                let weightVal = 1;
                if (sortAscending !== true) {
                  weightVal = -1;
                }

                let newData = data.sort((a, b) => {
                  if (
                    parseInt(a.get("filesize")) > parseInt(b.get("filesize"))
                  ) {
                    return weightVal;
                  } else if (
                    parseInt(b.get("filesize")) > parseInt(a.get("filesize"))
                  ) {
                    return weightVal * -1;
                  }
                  return 0;
                });
                return newData;
              }}
            />
            <ColumnDefinition
              id="date"
              title="Last Modified"
              sortMethod={(data, column, sortAscending) => {
                let weightVal = 1;
                if (sortAscending !== true) {
                  weightVal = -1;
                }

                let newData = data.sort((a, b) => {
                  let aDate = moment(a.get("date"));
                  let bDate = moment(b.get("date"));

                  if (bDate.isBefore(aDate)) {
                    return weightVal;
                  } else if (aDate.isBefore(bDate)) {
                    return weightVal * -1;
                  }
                  return 0;
                });
                return newData;
              }}
            />
            <ColumnDefinition id="actions" title="Actions" />
          </RowDefinition>
        </Griddle>
      );
    } else {
      return (
        <div>
          <Header as="h3">Files</Header>
          {this.missingFiles()}
        </div>
      );
    }
  }

  handleDragEnter() {
    this.setState({
      dragging: true
    });
  }

  handleDragLeave() {
    this.setState({
      dragging: false
    });
  }

  beforeSaveNewFilename() {
    this.setState({
      renamingFile: false,
      loading: true
    });
  }

  cancelRenameFile() {
    this.setState({
      renamingFile: false
    });
  }

  render() {
    let children = this.uploaderChildren;

    const uploadOptions = {
      server: Flagship.config.url,
      s3path: this.props.folder,
      getSignedUrl: this.getSignedUrl,
      uploadRequestHeaders: {}
    };

    return (
      <Segment>
        <DropzoneS3Uploader
          onFinish={this.handleFinishedUpload.bind(this)}
          onProgress={this.uploadProgress}
          onError={this.uploadError}
          children={children}
          passChildrenProps={false}
          s3Url={this.s3Url}
          maxSize={1024 * 1024 * 10000}
          upload={uploadOptions}
          onDragEnter={this.handleDragEnter}
          onDragLeave={this.handleDragLeave}
          className={this.state.dragging ? "files-dragging-over" : ""}
          style={{
            width: "100%",
            position: "relative",
            cursor: "pointer",
            overflow: "hidden",
            marginTop: "1em"
          }}
        />
        <RenameFileModal
          open={this.state.renamingFile !== false}
          initialFilename={this.state.renamingFile}
          onRenameFile={this.getFiles}
          beforeRenameFile={this.beforeSaveNewFilename}
          cancelRename={this.cancelRenameFile}
        />
      </Segment>
    );
  }
}

function mapStateToProps(state) {
  return {
    userRole: state.main.userRole,
    userMarket: state.main.userMarket,
    screenWidth: state.main.screenWidth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SingleRecordFiles);



// WEBPACK FOOTER //
// ./src/components/misc/SingleRecordFiles.js